
import Flickity from 'flickity';

const flickityClass = 'f-carousel';
const baseClass = 'logo-carousel';
const cellClass = `${ baseClass }__cell`;
const slideClass = `${ baseClass }__slide`;


const LogoCarousels = (() =>
{
	const c = {
		instances: [],
	}

	c.init = function ()
	{
		// Selects all elements with the class 'f-carousel' and 'logo-carousel' and converts the resulting NodeList into an array.
		const uninstantiated = Array.from(document.querySelectorAll(`.${ flickityClass }.${ baseClass }`));

		if (!uninstantiated.length)
		{
			return;
		}

		// Iterates over each element in the 'uninstantiated' array
		// and initializes a carousel using the 'initCarousel' function of an object called 'c'.
		uninstantiated.forEach(root =>
		{
			// Call the 'initCarousel' function of the 'c' object and pass the current element as an argument.
			const instance = c.initCarousel(root);

			// If the 'instance' object is truthy (i.e., not null or undefined), add it to the 'instances' array of the 'c' object.
			if (instance)
			{
				c.instances.push(instance);
			}
		});

		// Add event listeners to the window object.
		window.addEventListener('load', c.resizeInstances, { once: true });
		window.addEventListener('DOMContentLoaded', c.resizeInstances, { once: true });

		//TODO: debounce this
		window.addEventListener('resize', c.handleWindowResize);
	}

	// Initializes a carousel using the Flickity library.
	c.initCarousel = function (root)
	{
		const config = {
			accessibility: true,
			adaptiveHeight: false,
			autoPlay: true,
			cellAlign: 'left',
			draggable: true,
			groupCells: false,
			pageDots: false,
			percentPosition: false,
			prevNextButtons: false,
			resize: true,
			wrapAround: true,
		}

		const instance = new Flickity(root, config);

		return instance;
	}

	c.handleWindowResize = function (e)
	{
		// nothing to do
	}

	c.refreshInstances = function ()
	{
		// nothing to do
	}

	// Resizes all instances of the carousel.
	c.resizeInstances = function ()
	{
		c.instances.forEach(instance =>
		{
			instance.resize();
		})
	}

	return c;
})();


export default LogoCarousels;



// WEBPACK FOOTER //
// ./scripts/modules/logo-carousel.js